import { EElementCategory, IEFieldSource, IFieldElement, TElement } from '../types/calculator';
import { TNameOfFormState } from '../types/calculator/form';

export type IEnrichmentObject = Partial<Record<TNameOfFormState, IEFieldSource[]>>;

/**
 * Утилита для проверки, есть ли у филда source и есть ли в enrichmentObject данные для этого филда.
 */
const isNeedReplacement = (enrichmentObject: IEnrichmentObject, el: IFieldElement) =>
  enrichmentObject.hasOwnProperty(el.name) && el.source;

/**
 * Утилита для замены source в филде сторонними данными.
 * Поле source – это варианты для значений филда.
 * @see IScheme
 */
const replaceSourceData = (el: IFieldElement, enrichmentObject: IEnrichmentObject) => {
  if (isNeedReplacement(enrichmentObject, el)) {
    return { ...el, source: enrichmentObject[el.name] };
  }

  return el;
};

/**
 * Утилита для **обогащения** схемы элементов (полей формы) сторонними данными (например с бэка).
 *
 * @returns Схема элементов с обогащенными данными.
 * @example
 * // Для филдов payrollBank и regionId будут подставлены сторонние данные
 * const elementsScheme = getEnrichedSchema(FormScheme.elements, {
 *    payrollBank: banksOptions,
 *    regionId: regionsOptions,
 *  });
 */
export const getEnrichedSchema = (elements: TElement[], enrichmentObject: IEnrichmentObject): TElement[] => {
  return elements.map(el => {
    switch (el.category) {
      case EElementCategory.Field:
        return replaceSourceData(el, enrichmentObject);
      case EElementCategory.Group:
        return {
          ...el,
          elements: getEnrichedSchema(el.elements, enrichmentObject),
        };

      default:
        return el;
    }
  });
};
